module.exports = __webpack_public_path__ + "img/130.9.0c214a09.png";